export default "__VITE_ASSET__DRGgBDoe__"